import {AccountBriefRecord} from "../../../../account/types/AccountBriefRecord";

export interface SystemPrompt {
    readonly type: PromptType;
}

export enum PromptType {
    OPEN_ACCOUNT,
    OPEN_ACCOUNT_QUIZ,
    FUND_ACCOUNT,
    DELAYED,
    TEMP_MESSAGE,
    TEMP_AND_DELAYED,
    TRIAL_EXPIRING,
    NO_SUBSCRIPTION,
    SWIFT_READY,
    SWIFT_STARTED,
    MAINTENANCE
}

export interface OpenAccountSystemPrompt extends SystemPrompt {
    readonly type: PromptType.OPEN_ACCOUNT;
}

export function openAccountSystemPrompt(): OpenAccountSystemPrompt {
    return {
        type: PromptType.OPEN_ACCOUNT
    };
}

export interface DelayedAccountSystemPrompt extends SystemPrompt {
    readonly type: PromptType.DELAYED;
}

export function delayedAccountSystemPrompt(): DelayedAccountSystemPrompt {
    return {
        type: PromptType.DELAYED
    };
}

export interface TemporaryAndDelayedAccountSystemPrompt extends SystemPrompt {
    readonly type: PromptType.TEMP_AND_DELAYED;
}

export function temporaryAndDelayedAccountSystemPrompt(): TemporaryAndDelayedAccountSystemPrompt {
    return {
        type: PromptType.TEMP_AND_DELAYED
    };
}

export interface TempMessageAccountSystemPrompt extends SystemPrompt {
    readonly type: PromptType.TEMP_MESSAGE;
}

export function tempMessageAccountSystemPrompt(): TempMessageAccountSystemPrompt {
    return {
        type: PromptType.TEMP_MESSAGE
    };
}

export function isOpenAccountPrompt(prompt: SystemPrompt): prompt is OpenAccountSystemPrompt {
    return prompt.type === PromptType.OPEN_ACCOUNT;
}

export interface FundAccountSystemPrompt extends SystemPrompt {
    readonly type: PromptType.FUND_ACCOUNT;
    readonly account: AccountBriefRecord;
}

export function fundAccountPrompt(account: AccountBriefRecord): FundAccountSystemPrompt {
    return {
        type: PromptType.FUND_ACCOUNT,
        account
    };
}

export function isFundAccountPrompt(prompt: SystemPrompt): prompt is FundAccountSystemPrompt {
    return prompt.type === PromptType.FUND_ACCOUNT;
}

export interface TrialExpiringPrompt extends SystemPrompt {
    readonly type: PromptType.TRIAL_EXPIRING;
}

export function trialExpiringPrompt(): TrialExpiringPrompt {
    return {
        type: PromptType.TRIAL_EXPIRING
    };
}

export interface NoSubscriptionPrompt extends SystemPrompt {
    readonly type: PromptType.NO_SUBSCRIPTION;
}

export function noSubscriptionPrompt(): NoSubscriptionPrompt {
    return {
        type: PromptType.NO_SUBSCRIPTION
    };
}

export interface SwiftReadyPrompt extends SystemPrompt {
    readonly type: PromptType.SWIFT_READY;
}

export function swiftReadyPrompt(): SwiftReadyPrompt {
    return {
        type: PromptType.SWIFT_READY
    };
}

export interface SwiftStartedPrompt extends SystemPrompt {
    readonly type: PromptType.SWIFT_STARTED;
}

export function swiftStartedPrompt(): SwiftStartedPrompt {
    return {
        type: PromptType.SWIFT_STARTED
    };
}

export interface MaintenancePrompt extends SystemPrompt {
    readonly type: PromptType.MAINTENANCE;
}

export function maintenancePrompt(): MaintenancePrompt {
    return {
        type: PromptType.MAINTENANCE
    };
}
export interface OpenAccountQuizSystemPrompt extends SystemPrompt {
    readonly type: PromptType.OPEN_ACCOUNT_QUIZ;
}

export function openAccountQuizSystemPrompt(): OpenAccountQuizSystemPrompt {
    return {
        type: PromptType.OPEN_ACCOUNT_QUIZ
    };
}
